export const admin = {
  common: {
    loading: 'Loading…',
    loadingOrganiser: 'Loading organiser…',
    couldNotLoadEvents: 'Could not load events',
    noEventsAvailable: 'No events available',
    getTickets: 'Get Tickets',
    soldOut: 'Sold Out',
    free: 'Free',
    view: 'View',
    online: 'Online',
    ticketsLeft: '{remaining} left',
    saveEvent: 'Save event',
    removeFromSaved: 'Remove from saved',
    datesCount: '{count} dates',
  },
  app: {},
  organiser: {
    loadErrorTitle: 'Could not load organiser information',
    eventsByOrganiser: 'Events by {organiserName}',
    noEventsBody: 'Check back soon for upcoming events.',
  },
  instancePicker: {
    title: 'Choose your event',
    subtitle: 'Select an organiser to browse and buy tickets.',
    browseAllTitle: 'Browse all events',
    browseAllDescription: 'View events from all organisers in one place',
    browseEvents: 'Browse events',
  },
  directory: {
    loadingEvents: 'Loading events...',
    searchPlaceholder: 'Search events, organisers, locations…',
    title: 'Event Directory',
    seoTitle: 'Event Directory — Browse all events',
    seoDescription: 'Discover events from organisers across the platform. Browse, filter, and get tickets.',
    jsonldListName: 'Event Directory',
    jsonldListDescription: 'Events from multiple organisers',
    eventsCountFromAllOne: '1 event from all organisers',
    eventsCountFromAllOther: '{count} events from all organisers',
    browseEventsFromAll: 'Browse events from all organisers',
    sortUpcoming: 'Upcoming first',
    sortPriceLowHigh: 'Price: low to high',
    sortNameAZ: 'Name A–Z',
    inPerson: 'In person',
    saved: 'Saved',
    locationPlaceholder: 'Location',
    allLocations: 'All locations',
    clearFilters: 'Clear filters ({count})',
    categoryAll: 'All',
    noSavedEvents: 'No saved events',
    noSavedEventsBody: 'Save events by clicking the ♡ on any event card.',
    noEventsFound: 'No events found',
    noEventsFoundFilteredBody: 'Try a different search or clear some filters.',
    noEventsFoundBody: 'No events are currently listed in the directory.',
    loadMoreEvents: 'Load more events',
    showingCount: 'Showing {shown} of {total}',
    organiserNotFound: 'Organiser not found',
    backToDirectory: 'Back to directory',
    upcomingEvents: 'Upcoming events',
    eventsListedCountOne: '1 event listed',
    eventsListedCountOther: '{count} events listed',
    noEventsListed: 'No events listed',
    noEventsListedBody: "This organiser hasn't listed any events in the directory yet.",
    allEventsButton: 'All events',
    organiserSeoTitle: '{organiserName} — Events',
    organiserSeoDescriptionFallback: 'Browse upcoming events from {organiserName}.',
  },
  ticketingEnabledGuard: {
    title: 'Ticketing unavailable',
    description: 'This organiser does not currently offer ticket sales.',
  },
};
